import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/Admin/layout/layout.vue'
import Exam from './views/exam.vue'
import Verify from './views/verify.vue'
import ExamWp from './views/exam_wp.vue'
import Cert from './views/Cert.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/rules/:id',
      name: 'rules',
      meta: { title: '考试守则页', icon: 'dashboard', auth: 'user' },
      component: () => import('@/views/rules.vue'),
    },
    {
      path: '/entrance/:id',
      name: 'entrance',
      meta: { title: '入口页', icon: 'dashboard', auth: 'user' },
      component: () => import('@/views/entrance.vue'),
    },
    {
      path: '/main/:id',
      name: 'main',
      meta: { title: '主页', icon: 'dashboard', auth: 'car' },
      component: () => import('@/views/main.vue'),
    },
    {
      path: '/papertable',
      name: 'paperTable',
      meta: { title: '顺序卷列表', icon: 'dashboard', auth: 'car' },
      component: () => import('@/views/paperTable.vue'),
    },
    {
      path: '/personalPaper',
      name: 'personalPaper',
      meta: { title: '顺序卷列表', icon: 'dashboard', auth: 'car' },
      component: () => import('@/views/personalPaper.vue'),
    },
    {
      path: '/exam/:id',
      name: 'exam',
      meta: { title: '考试页', icon: 'dashboard', auth: 'user' },
      component: Exam,
    },
    {
      path: '/verify/:id',
      name: 'verify',
      meta: { title: '认证页', icon: 'dashboard', auth: 'user' },
      component: Verify,
    },
    {
      path: '/cert',
      name: 'cert',
      meta: { title: '实名认证', icon: 'dashboard', auth: 'user' },
      component: Cert,
    },
    {
      path: '/exam_wp/:id',
      name: 'exam_wp',
      meta: { title: '考试页', icon: 'dashboard', auth: 'user' },
      component: ExamWp,
    },
    {
      path: '/practice',
      name: 'practice',
      meta: { title: '错题练习', icon: 'dashboard', auth: 'car' },
      component: () => import('@/views/practice.vue'),
    },
    {
      path: '/toPractice',
      name: 'ToPractice',
      meta: { title: '顺序练习', icon: 'dashboard', auth: '' },
      component: () => import('@/views/toPractice.vue'),
    },

    {
      path: '/',
      name: 'index',
      meta: { title: '登录页', icon: 'dashboard', auth: 'Admin' },
      component: () => import('@/views/Admin/login/login'),
    },
    {
      path: '/404',
      name: 'NOT FOUND',
      meta: { title: '404', icon: 'dashboard', auth: 'Admin' },
      component: () => import('@/views/Admin/login/404.vue'),
    },
    {
      path: '/Admin/export/:id?',
      name: 'Export',
      hidden: true,
      meta: { title: '成绩导出', auth: 'Admin', icon: '' },
      component: () => import('@/views/Admin/examination/export'),
    },
    {
      path: '/login',
      name: 'login',
      meta: { title: '登录页', icon: 'dashboard', auth: 'Admin' },
      component: () => import('@/views/Admin/login/login'),
    },
    {
      path: '/Admin/paperList',
      name: 'PaperList',
      component: Layout,
      meta: { title: '新增试卷', icon: 'dashboard', auth: 'Admin' },
      children: [
        {
          path: '/Admin/paperList',
          name: 'PaperListIndex',
          hidden: false,
          meta: { title: '试卷列表', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/paperList'),
        },
        {
          path: '/Admin/database',
          name: 'DatabaseIndex',
          hidden: false,
          meta: { title: '题库', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/database'),
        },
        {
          path: '/Admin/editPaper/index/:id',
          name: 'EditPaperIndex',
          hidden: true,
          meta: { title: '录入试题', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/editPaper'),
        },
        {
          path: '/Admin/paperResult/:id',
          name: 'LookOver',
          hidden: true,
          meta: { title: '试卷答题情况', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/paperResult'),
        },
        {
          path: '/Admin/paperAnalysis/:id',
          name: 'PaperAnalysis',
          hidden: true,
          meta: { title: '试卷分析', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/paperAnalysis'),
        },
        {
          path: '/Admin/Result/:id',
          name: 'LookOver',
          hidden: true,
          meta: { title: '试卷答题情况', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/Result'),
        },
        {
          path: '/Admin/chapter',
          name: 'Chapter',
          hidden: false,
          meta: { title: '科目章节', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/chapter'),
        },
        {
          path: '/Admin/invigilate',
          name: 'invigilate',
          hidden: true,
          meta: { title: '监考记录', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/invigilate'),
        },
        {
          path: '/Admin/invigilateChart',
          name: 'invigilateChart',
          hidden: true,
          meta: { title: '监考记录', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/invigilateChart'),
        },
        {
          path: '/Admin/examResult/:id?',
          name: 'examResult',
          hidden: true,
          meta: { title: '考试详情', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/examResult'),
        },
        {
          path: '/Admin/orderList',
          name: 'orderList',
          hidden: true,
          meta: { title: '订单列表', auth: 'Admin', icon: '' },
          component: () => import('@/views/Admin/examination/orderList'),
        },
      ],
    },
  ],
})
